import {Module} from '@fantasmagames/slot/src/common/Module';
import {CheatView} from '@fantasmagames/slot/src/modules/cheat/CheatView';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {CheatDebuggingComponent} from '@fantasmagames/slot/src/modules/cheat/debuggingComponent/CheatDebuggingComponent';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {LogotypeViewEvents} from '@fantasmagames/slot/src/modules/logotype/LogotypeViewEvents';
import {Logic} from '@fantasmagames/slot/src/logic/Logic';

export class CheatModule extends Module<CheatView> {
	protected enterFirstState(): void {}

	protected setupStates(): void {}

	protected setupViews(): void {
		this.setView(Views.CHEATS_VIEW);
	}

	protected setupEvents(): void {
		super.setupEvents();

		if (!__PRODUCTION__) {
			this.on(LogotypeViewEvents.LOGOTYPE_DOUBLE_TAPPED, this.onDoubleTapLogo);
			this.on(LogicEvents.INIT_RESPONSE, this.onInitResponse);
		}
	}

	protected onInitResponse(): void {
		this.view.addMathVersion((this.logic as Logic).mathVersion);
	}

	public addDebuggingComponent(): void {
		if (!__PRODUCTION__) {
			new CheatDebuggingComponent(this, this.view);
			document.addEventListener('keydown', this.keyboardInput.bind(this));
		}
	}

	protected onDoubleTapLogo(): void {
		this.switchCheatsVisibility();
	}

	protected switchCheatsVisibility(): void {
		if (this.view.isVisible()) {
			this.view.hide();
		} else {
			this.view.show();
		}
	}

	protected keyboardInput(event: KeyboardEvent): void {
		if (event.code === 'KeyC') {
			this.switchCheatsVisibility();
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/cheat/CheatModule.ts